export enum NavigationDirection {
  UP = -1,
  DOWN = 1,
}
